import { render, staticRenderFns } from "./SampleIndexNavPanel.vue?vue&type=template&id=64cb0bde&scoped=true&"
import script from "./SampleIndexNavPanel.vue?vue&type=script&lang=js&"
export * from "./SampleIndexNavPanel.vue?vue&type=script&lang=js&"
import style0 from "./SampleIndexNavPanel.vue?vue&type=style&index=0&id=64cb0bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb0bde",
  null
  
)

export default component.exports